/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import styled from 'styled-components';

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-items: flex-start;
  margin-top: ${({theme}) => theme.getSize(2)};
`;

export const TooltipWrapper = styled.div``;
